import DeskDto from '@/models/Desks/DeskDto';
import BaseAgencyScopeEntityDto from '@/models/Shared/BaseAgencyScopeEntityDto';
import GeoPoint from '@/models/Shared/GeoPoint';
import IAddressLine from '@/models/Shared/IAddressLine';

export default class BranchDto extends BaseAgencyScopeEntityDto implements IAddressLine {
    status = 90;
    registeredName = '';    
    brandName = '';
    emailAddress = '';
    phoneNumber = '';
    taxNumber = '';    
    registrationNumber = '';
    buildingNameNumber = '';
    streetRoadBlock = '';
    locality = '';
    cityTown = '';
    stateProvinceRegion = '';
    postZipCode = '';
    countryCode = '';
    geometry: GeoPoint = new GeoPoint();
    isExactGeo: boolean;
    website = '';
    biography = '';
    //avatar: string = '';
    desks: DeskDto[] = [];

     //These two properties are used to make the settings treeview work in a generic way
     name = '';
     isBranch = true;
}